// 我的档案相关
const Archives = () => import('../pages/archives/index.vue');
const OwnArchives = () => import('../pages/archives/ownArchives.vue');

export default [
  {
    path: '/archives',
    component: Archives,
    meta: {
      title: '我的档案',
    },
  },
  {
    path: '/ownarchives',
    component: OwnArchives,
    meta: {
      title: '我的档案',
    },
  },
];
